<template>
  <div class="list-head">
    <div class="header-wrap header-public clearfix">
      <div class="header-left cleearfix">
        <i class="icon-czur-logo"></i>
        <div class="header-function">
          <div class="function-bar">
            <span>{{$t('index.notebook')}}</span>
            <i class="icon-down-arrow"></i>
          </div>
          <div class="function-list">
            <div class="function-li" @click="changeActiveProduct('index.html#/et')">
              <img class="function-li-img" src="../../assets/images/et_nav.png" alt="">
              <div class="function-li-title">ET</div>
            </div>
            <div class="function-li active" @click="changeActiveProduct('index.html#/notebook')">
              <img class="function-li-img" src="../../assets/images/notebook_nav.png" alt="">
              <div class="function-li-title">{{$t('index.notebook')}}</div>
            </div>
<!--             <div class="function-li" @click="changeActiveProduct('starry.html#/starry/cloudSynchronizationFile/all')">
              <img class="function-li-img" src="../../assets/images/starry_nav.png" alt="">
              <div class="function-li-title">投影仪</div>
            </div> -->
          </div>
        </div>
      </div>
      <div class="nav" :class="{'notebook': mode == 3, 'tag': mode == 4, 'pdf': mode == 5}">
        <div class="nav-li" :class="{'active': mode == 3}" @click="modeChange(3)">{{$t('index.notebook')}}<div class="nav-active"></div></div>
        <div class="nav-li" :class="{'active': mode == 4}" @click="modeChange(4)">{{$t('list.label')}}<div class="nav-active"></div></div>
        <div class="nav-li" :class="{'active': mode == 5, 'hidden': pdfHide}" @click="modeChange(5)">PDF<div class="nav-active"></div></div>
      </div>
      <div class="header-right header-right-notebook clearfix">
        <div class="user-informations clearfix">
          <img class="header-img" v-if="defaultHeaderImg" src="../../assets/images/default_header_img.png" alt="">
          <img class="header-img" v-if="!defaultHeaderImg" :src="src" alt="">
          <div class="user-wrap">
            <div class="user-name-wrap">
              <span class="user-name">{{userName}}</span>
              <i class="icon-down-arrow"></i>
            </div>
            <div class="user-list">
              <a class="user-list-li" @click="goPersonalInformation">{{$t('list.accountCenter')}}</a>
              <a class="user-list-li" @click="exit">{{$t('list.logOut')}}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HttpClient from 'common/script/http'
import * as Config from 'common/script/config'
import Validate from 'common/script/validate'
export default {
  name: 'listHead',
  props: ['selectedNum', 'mode'],
  data () {
    return {
      defaultHeaderImg: true,
      src: '',
      userName: '',
      uId: Config.cookieGet(Config.COOKIE_KEY.U_ID),
      email: '',
      pdfHide: true
    }
  },
  created () {
    this.checkPdfStatus()
    this.getUserInfo()
  },
  mounted () {
    window.addEventListener('hashchange', this.hashchange)
  },
  methods: {
    openPdfMode: function () {
      this.pdfHide = false
    },
    checkPdfStatus: function () {
      HttpClient.getData(Config.APP_HOST + '/v1/book/getPdfByUserId?u_id=' + this.uId, this).then((response) => {
        if (response.code === Config.R_CODE.SUCCESS) {
          if (response.body.length > 0) {
            this.pdfHide = false
          } else {
            if (this.mode === 5) {
              this.$router.push('/notebook/notebook')
            }
          }
        }
      })
    },
    hashchange: function () {
      location.reload()
    },
    changeActiveProduct: function (val) {
      window.location.href = val
    },
    closeSelected: function () {
      this.$emit('closeSelected')
    },
    goPersonalInformation: function () {
      var url = Config.PASSPORT_HOST + '/basic.html?token=' + Config.cookieGet(Config.COOKIE_KEY.TOKEN) + '&u_id=' + Config.cookieGet(Config.COOKIE_KEY.U_ID) + '&Channel=' + Config.CHANNEL + '&lang=' + Validate.lang() + '#/baiscPage'
      window.open(url, '_blank')
    },
    exit: function () {
      HttpClient.getData(Config.APP_HOST + '/v1/user/logout').then((response) => {
        Config.cookieSet(Config.COOKIE_KEY.U_ID, '')
        Config.cookieSet(Config.COOKIE_KEY.TOKEN, '')
        Config.cookieSet(Config.COOKIE_KEY.USER_NAME, '')
        window.location.href = '/?action=logout' // &callback=' + encodeURIComponent(window.location)
      })
    },
    modeChange: function (val) {
      this.$emit('modeChange', val)
    },
    getUserInfo: function () {
      HttpClient.getData(Config.APP_HOST + '/v1/user/info?u_id=' + this.uId, this).then((response) => {
        if (response.code === Config.R_CODE.SUCCESS) {
          if (response.body.photo) {
            this.defaultHeaderImg = false
            this.src = response.body.photo
          }
          this.userName = response.body.name
          this.email = response.body.email
          this.$emit('getUserInfo', this.userName, this.email)
        }
      })
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
.list-head
  width 100%
  height 50px
  line-height 50px
  position fixed
  top 0
  left 0
  right 0
  bottom 0
  color #3d3d3d
  z-index 99
  .header-wrap
    &.header-public
      width 100%
      height 100%
      background-color #fff
      border-bottom 1px solid #ebebeb
      font-size 14px
      display block
      position relative
      .header-left
        float left
        .icon-czur-logo
          float left
          margin 14px 34px 14px 20px
          font-size 22px
          color #3d3d3d
        .header-function
          float left
          width 83px
          &:hover
            .function-list
              display block
          .function-bar
            text-align left
            .icon-down-arrow
              vertical-align middle
          .function-list
            width 292px
            height 128px
            border 1px solid #e9e9e9
            margin-top -10px
            background-color #fff
            position absolute
            left 20px
            display none
            .function-li
              display inline-block
              width 70px
              margin 19px 22px 10px 22px
              cursor pointer
              .function-li-img
                display block
                margin-bottom 9px
              .function-li-title
                font-size 12px
                width 62px
                height 18px
                margin-left 4px
                line-height 18px
                border 1px solid transparent
                border-radius 10px
              &.active
                .function-li-title
                  color rgba(9, 130, 203, 0.5)
                  border-color rgba(9, 130, 203, 0.5)
                  background-color #f5fbff
      .nav
        display inline-block
        position relative
        color #9b9b9b
        .nav-li
          display inline-block
          width 70px
          margin 0 5px
          cursor pointer
          position relative
          .nav-active
            position absolute
            width 20px
            height 2px
            background-color #3d3d3d
            left 50%
            bottom 0px
            margin-left -10px
            transition all 0.2s ease-in
            opacity 0
          &.active
            color #3d3d3d
            .nav-active
              opacity 1
          &:hover
            color #3d3d3d
          &.hidden
            display none
      .header-right
        float right
        &.header-right-notebook
          padding-left 66px
        .user-informations
          float right
          width 154px
          height 32px
          margin 9px 0
          .header-img
            float left
            width 32px
            height 32px
            margin-right 10px
            border-radius 50%
          .user-wrap
            float left
            width 110px
            height 100%
            line-height 32px
            position relative
            text-align left
            &:hover
              .user-name-wrap
                .icon-down-arrow
                  animation rotate .5s
              .user-list
                display block
            .user-name-wrap
              cursor pointer
              .user-name
                display inline-block
                max-width 90px
                height 18px
                line-height 18px
                white-space nowrap
                text-overflow ellipsis
                overflow hidden
                vertical-align middle
              .icon-down-arrow
                font-size 12px
                vertical-align text-bottom
            .user-list
              display none
              width 108px
              height 60px
              position absolute
              top 30px
              right 0
              padding 6px 0px
              background-color #fff
              font-size 12px
              border 1px solid #f2f2f2
              border-radius 4px
              .user-list-li
                display block
                height 30px
                line-height 30px
                text-align center
                cursor pointer
@keyframes rotate
  0%
    transform rotate(0deg)
  100%
    transform rotate(45deg)
</style>



// WEBPACK FOOTER //
// src/components/Notebook/ListHead.vue